import { FormattedMessage } from 'react-intl';

import { PERMISSION } from 'src/features/auth/types';
import { visitorMessages } from 'src/features/visitor/utils/messages';
import { STAY_TYPE } from 'src/features/stay/types';
import GatewayPassesTable from 'src/features/gatewayPass/components/GatewayPassesTable';
import StayPeriodsTable from 'src/features/stay/components/dashboard/StayPeriodsTable';
import useHasPermissions from 'src/hooks/useHasPermissions';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'src/registry/ui/Tabs';
import { useSearchParams } from 'react-router-dom';
import PaymentsTable from 'src/features/payment/components/tables/PaymentsTable';
import { PAYMENT_ITEM_TYPE } from 'src/features/payment/utils/types';

type StayDashboardTablesProps = {
    stayType?: STAY_TYPE;
    stayId?: string;
};

const StayDashboardTables = ({ stayType, stayId }: StayDashboardTablesProps) => {
    const accessGatewayPassesPermission = useHasPermissions([PERMISSION.ACCESS_GATEWAY_PASSES]);
    const accessPaymentsPermission = useHasPermissions([PERMISSION.ACCESS_PAYMENTS]);

    const [searchParams, setSearchParams] = useSearchParams();

    const defaultTab = 'periods';
    const tab = searchParams.get('tab') ?? defaultTab;

    const itemType: PAYMENT_ITEM_TYPE =
        stayType === STAY_TYPE.ACTIVE ? PAYMENT_ITEM_TYPE.ACTIVE_STAY : PAYMENT_ITEM_TYPE.PAST_STAY;

    return (
        <div className="grid flex-3 grid-cols-1">
            <Tabs
                defaultValue={defaultTab}
                value={tab}
                onValueChange={(value) => setSearchParams({ tab: value }, { replace: true })}
            >
                <TabsList>
                    <TabsTrigger value="periods">
                        <FormattedMessage {...visitorMessages.stayPeriods} />
                    </TabsTrigger>

                    {accessGatewayPassesPermission && (
                        <TabsTrigger value="gateway-passes">
                            <FormattedMessage {...visitorMessages.gatewayPasses} />
                        </TabsTrigger>
                    )}

                    {accessPaymentsPermission && (
                        <TabsTrigger value="payments">
                            <FormattedMessage {...visitorMessages.payments} />
                        </TabsTrigger>
                    )}
                </TabsList>

                <TabsContent value="periods">
                    <StayPeriodsTable stayType={stayType} />
                </TabsContent>

                {accessGatewayPassesPermission && (
                    <TabsContent value="gateway-passes">
                        <GatewayPassesTable stayType={stayType} />
                    </TabsContent>
                )}

                {accessPaymentsPermission && (
                    <TabsContent value="payments">
                        <PaymentsTable itemId={stayId} itemType={itemType} />
                    </TabsContent>
                )}
            </Tabs>
        </div>
    );
};

export default StayDashboardTables;
